import { Skeleton } from "components/skeleton";
import { Text } from "components/text";
import { ListItem } from "components/List/ListItem";

interface KeywordsListSkeletonProps {
  count: number;
}

const FALLBACK_COUNT = 15;

export const KeywordsListSkeleton = ({ count }: KeywordsListSkeletonProps) => {
  const rowCount = count > 0 ? count : FALLBACK_COUNT;

  return (
    <ul
      className="flex w-full flex-col m-0 p-0 list-none items-start justify-start"
      data-testid="keywords-list-skeleton"
    >
      {Array.from({ length: rowCount }).map((_, index) => (
        <li
          // biome-ignore lint/suspicious/noArrayIndexKey: skeleton rows are positional placeholders
          key={`keyword-skeleton-${index}`}
          className="w-full divide-y divide-secondary-100"
        >
          <ListItem testId={`keyword-skeleton-row-${index}`}>
            <div className="flex flex-row w-full items-center gap-2">
              <Text as="span" variant="subtle" className="min-w-6">
                {index + 1}.
              </Text>
              <Skeleton className="h-4 flex-1" />
            </div>
          </ListItem>
        </li>
      ))}
    </ul>
  );
};
